const TokenKey = 'sb-qiurdoiahrcovgmxmwqi-auth-token'
export function getToken() {
   return localStorage.getItem(TokenKey)
}
